import { ProductWithBundleId } from '~/models/CampaignModel';
import { ConditionType, ProductCondition, ProductConditionSet } from '../../models/product/Notifications';

// PRODUCT CONDITIONS
export const validateProductConditions = (basketProducts: ProductWithBundleId[], conditions: ProductConditionSet) => {
  let result = true;

  if (conditions && conditions.productConditionsAny !== null) {
    const hits = evaluateConditionGroup(basketProducts, conditions.productConditionsAny);
    if (hits.length === 0) result = false;
  }

  if (conditions && conditions.productConditionsAll !== null) {
    const hits = evaluateConditionGroup(basketProducts, conditions.productConditionsAll);
    if (hits.length !== conditions.productConditionsAll.length) result = false;
  }

  return result;
};

const evaluateConditionGroup = (products: ProductWithBundleId[], conditions: ProductCondition[]) =>
  conditions.map((condition) => evaluateCondition(products, condition)).filter((x) => x === true);

const evaluateCondition = (products: ProductWithBundleId[], condition: ProductCondition) => {
  const quantityInBasket = products.filter((x) => x.offer.commercialProductId === condition.commercialProductId).length;
  switch (condition.conditionType) {
    case ConditionType.LessOrEqual:
      return quantityInBasket <= condition.quantity;
    case ConditionType.Equal:
      return quantityInBasket === condition.quantity;
    case ConditionType.GreaterOrEqual:
      return quantityInBasket >= condition.quantity;
    default:
      return false;
  }
};
